import styled from 'styled-components';

import { SideItemType } from '~/core/enums';
import InputOptionSt from '~molecules/InputOption';
import SideItemInputHeight from '~molecules/SideItemInputHeight';

export const Container = styled.div(({ theme }) => ({
  [`.${InputOptionSt}:has([data-side-type="${SideItemType.WALL_SIDE}"])`]: {
    paddingInlineStart: '22rem',
    paddingBlockStart: '20rem',

    color: theme.palette.darkJungleGreen,
    fontSize: theme.typography.size14,
  },
}));

export const SideItemHeight = styled(SideItemInputHeight)({
  marginInlineStart: '55rem',
});
